import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import {
  QuestionnaireApi,
  QuestionnaireDossier,
  QuestionnairePrefill,
  QuestionnaireSubmission,
} from '../tokens/questionnaire.token';

/**
 * REST-only implementation of {@link QuestionnaireApi} (EM-1772, story EM-1672).
 *
 * Thin `HttpClient` wrapper over the live `QuestionnaireResource` at
 * `/services/embedded/api/v1`. No mock, no fallback (Rules 07/10). The auto-population, the
 * read-only derivation and the provenance of every value are the backend's job — this service adds no
 * parsing and no rules of its own (Rule 17). Rides the Keycloak bearer via `authInterceptor`.
 */
@Injectable()
export class QuestionnaireRestService implements QuestionnaireApi {
  private readonly http = inject(HttpClient);

  prefill(product: string, debtorCuis?: string[]): Observable<QuestionnairePrefill> {
    let params = new HttpParams().set('product', product);
    for (const cui of debtorCuis ?? []) {
      const trimmed = (cui ?? '').trim();
      if (trimmed) {
        // `append`, not `set` — the backend takes `debtorCui` repeatably, one per debtor block.
        params = params.append('debtorCui', trimmed);
      }
    }
    return this.http.get<QuestionnairePrefill>(`${API_PATHS.FINANCING_QUESTIONNAIRE}/prefill`, { params });
  }

  load(applicationId: number): Observable<QuestionnaireDossier> {
    return this.http.get<QuestionnaireDossier>(`${API_PATHS.FINANCING_APPLICATIONS}/${applicationId}/questionnaire`);
  }

  update(applicationId: number, body: QuestionnaireSubmission): Observable<void> {
    return this.http.put<void>(`${API_PATHS.FINANCING_APPLICATIONS}/${applicationId}/questionnaire`, body);
  }
}
